import React from 'react';
import { PLAYBACK_TYPE } from 'services/constants';
import { CreativeType } from 'types/creative';
import { useAppState } from 'context';
import { classSize } from 'services/constants';
import KervLogo from 'components/atoms/KervLogo/KervLogo';
import './AppHeader.scss';
import HeaderIcons from '../HeaderIcons';

const AppHeader = () => {
  const { creative: { name } = {} as CreativeType, screenSizeClass } = useAppState();

  return (
    <div className={`header ${screenSizeClass}`}>
      {screenSizeClass === classSize.sm && <KervLogo />}
      <h1>
        {name}
      </h1>
      {screenSizeClass === classSize.lg && <HeaderIcons/>}
    </div>
  );
}

export default AppHeader;
